import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsSection2 } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1975701953338788');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans pb-16 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Benefits data-id="element-4" />
      <ProductShowcase data-id="element-5" />
      <Bonuses data-id="element-6" />
      <PurchaseSection id="compra" data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Guarantee data-id="element-9" />
      <TestimonialsSection2 data-id="element-10" />
      <FAQ data-id="element-11" />
      <PurchaseSection data-id="element-12" />

      {/* Closing CTA Section */}
      <section className="py-8 md:py-12 px-4 bg-brand-dark text-center border-t border-brand-accent/10" data-id="element-13">
        <div className="max-w-2xl mx-auto" data-id="element-14">
          <h2 className="text-xl md:text-3xl font-black text-white mb-3 tracking-tight leading-tight uppercase" data-id="element-15">
            ¿Listo para transformar tu año de{' '}
            <span className="text-brand-accent neon-glow" data-id="element-16">
              Educación Financiera
            </span>
            ?
          </h2>
          <p className="text-sm md:text-base text-gray-300 font-bold leading-relaxed" data-id="element-17">
            Más de{' '}
            <span className="text-brand-accent font-black" data-id="element-18">5.000 docentes</span>{' '}
            ya lo están usando.
          </p>
        </div>
      </section>

      <Footer data-id="element-19" />
      <SocialProofPopup data-id="element-20" />
      <StickyMobileCTA data-id="element-21" />

      <noscript data-id="element-22">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1975701953338788&ev=PageView&noscript=1" alt="" data-id="element-23" />
      </noscript>
    </div>;
}